// extracted by css-extract-rspack-plugin
export default {"root":"FileListGalleryItemThumbnailFallback_root__kOqIn"};